

















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as utils from '@/utils';
import GenericDropdown from '@/components/GenericDropdown.vue';                       // @ is an alias to /src
import MomentTransferredListComponent from '@/components/MomentTransferredListComponent.vue';                       // @ is an alias to /src
import * as utils_tracker from '@/utils_tracker';
import * as utils_topshot from '@/utils_topshot';
import { MomentTransferred, sortOrderTypes } from '@/MomentTransferred'
import { GiftingList } from '@/GiftingList'
import { IPaginationResult } from '@/PaginationResult'
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src

@Component({
  name: 'Gifters',
  components: { GenericDropdown, MomentTransferredListComponent, ModalWrapperComponent }
})

export default class GiftersComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop()
  public senderAddress: string

  @Prop()
  public receiverAddress: string

  // public reactive member variables available to the html template
  public lastFetchedURL: string = null;
  public moments: MomentTransferred[] = []
  public giftingList: GiftingList = null
  public paginationResult: IPaginationResult = null
  public numMoments: number = null

  // UI and filter options
  public sender: { label: string, flowAddress: string } = { label: 'Top senders', flowAddress: null }
  public senders: Array<{ label: string, flowAddress: string }> = []
  public receiver: { label: string, flowAddress: string } = { label: 'Top receivers', flowAddress: null }
  public receivers: Array<{ label: string, flowAddress: string }> = []

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }

  @Watch('sender')
  public async onChangedSender(user: { label: string, flowAddress: string }) {
    if (this.$store.state.devmode) console.log(`onChangedSender()`)
    this.sender = user ? user : { label: 'Top senders', flowAddress: null }
    this.moments = []
    this.numMoments = 0
    this.pageNumberToLoadNext = 1
    this.senderAddressToUseWhenReady = null
    await this.fetchData(false, this.pageNumberToLoadNext)
  }

  @Watch('receiver')
  public async onChangedReceiver(user: { label: string, flowAddress: string }) {
    if (this.$store.state.devmode) console.log(`onChangedReceiver()`)
    this.receiver = user ? user : { label: 'Top receivers', flowAddress: null }
    this.moments = []
    this.numMoments = 0
    this.pageNumberToLoadNext = 1
    this.receiverAddressToUseWhenReady = null
    await this.fetchData(false, this.pageNumberToLoadNext)
  }  

  public async onClickedSender(flowAddress: string) {
    let foundOneInExistingList: boolean
    if (this.$store.state.devmode) console.log(`onClickedSender()`)
    for (const sender of this.senders) {
      if (sender.flowAddress === flowAddress) {
        foundOneInExistingList = true
        this.onChangedSender(sender)
        break;
      }
    }
    if (!foundOneInExistingList) {
      const addOne: { label: string, flowAddress: string } = { label: flowAddress, flowAddress }
      this.senders.push(addOne)
      this.onChangedSender(addOne)
    }
  }
  public async onClickedReceiver(flowAddress: string) {
    let foundOneInExistingList: boolean
    if (this.$store.state.devmode) console.log(`onClickedReceiver()`)
    for (const receiver of this.receivers) {
      if (receiver.flowAddress === flowAddress) {
        foundOneInExistingList = true
        this.onChangedReceiver(receiver)
        break;
      }
    }
    if (!foundOneInExistingList) {
      const addOne: { label: string, flowAddress: string } = { label: flowAddress, flowAddress }
      this.receivers.push(addOne)
      this.onChangedReceiver(addOne)
    }    
  }

  public showFAQ(): void {
    (this.$refs.FAQGiftersComponent as ModalWrapperComponent).show('Top Gifters FAQ', 'md', null)
  }    

  public async infiniteHandler(state: any): Promise<void> {
    const numReturned: number = await this.fetchData(true, this.pageNumberToLoadNext)
    if (numReturned === 0) {
      if (this.$store.state.devmode) console.log(`infiniteHandler(): state.complete after getting 0 items`)
      state.complete()
    } else {
      state.loaded();
    }
  }

  // private, non-reactive member variables
  private lastFetchSucceeded: boolean;
  private pageNumberToLoadNext: number = 1
  private senderAddressToUseWhenReady: string = null
  private receiverAddressToUseWhenReady: string = null

  @Watch('$route.path')
  private async pathChanged(): Promise<void> {
    if (this.$store.state.devmode) console.log(`GiftersComponent.pathChanged() ${this.$route.path}`)
  }


  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`);

    utils_tracker.page(this.$options.name)

    // from props
    this.senderAddressToUseWhenReady = this.senderAddress
    this.receiverAddressToUseWhenReady = this.receiverAddress

    // from url
    if (this.$route.query.sender) this.senderAddressToUseWhenReady = this.$route.query.sender as string
    if (this.$route.query.receiver) this.receiverAddressToUseWhenReady = this.$route.query.receiver as string

    await this.fetchData(false, this.pageNumberToLoadNext)

  }

  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)
  }

  // add flowAddresses as query params to current url path
  private addParamsToURL() {
    let extra: string = ''
    if (this.sender && this.sender.flowAddress) extra += `&sender=${encodeURIComponent(this.sender.flowAddress)}`
    if (this.receiver && this.receiver.flowAddress) extra += `&receiver=${encodeURIComponent(this.receiver.flowAddress)}`
    extra = extra.replace('&', '?')     // replace only the first one
    this.$router.replace(`${this.$route.path}${extra}`).catch(() => {})
  }

  private async fetchData(calledByInfiniteHandlerOrTimer: boolean, pageNumberWhenCalled: number): Promise<number> {
    this.addParamsToURL()

    const fakeMoment: MomentTransferred = new MomentTransferred(null)
    fakeMoment.momentID = 0
    fakeMoment.valueFMV = 0

    let url: string = utils.getURLprefix() + `/api/topshot/gifts/`;
    url += `?page=${pageNumberWhenCalled}`;
    if (this.sender && this.sender.flowAddress) url += '&sender=' + encodeURIComponent(this.sender.flowAddress)
    if (this.receiver && this.receiver.flowAddress) url += '&receiver=' + encodeURIComponent(this.receiver.flowAddress)

    // don't fetch if we're in the middle of fetching same url
    if (this.loading) {
      if (this.lastFetchedURL === url || calledByInfiniteHandlerOrTimer) {
        if (this.$store.state.devmode) console.log(`GiftersComponent.fetchData() aborting calledByInfiniteHandler and we're already loading`)
        await utils.sleep(1000)     // wait 1 s so we don't go into 100% CPU infinite loop
        return
      }
    }

    this.$store.commit('setLoading', { loading: true });
    this.lastFetchedURL = url;

    try {
      // console.log(url)
      this.lastFetchSucceeded = false;
      const response: any = await utils.makeGetCall(url);

      // whoa, we got another call after this one, so let's abort this one cuz the latest one should take precedent
      if (this.lastFetchedURL !== url) return

      // in case old version
      if (utils.isClientOld()) {
        if (this.$store.state.devmode) console.log("Calling this.$router.go(0)");
        this.$router.go(0);
        this.$store.commit('setLoading', { loading: false });
        return;
      }

      // error check
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
        this.$store.commit('setLoading', { loading: false });
        return
      }
      // pagination result
      this.paginationResult = response.data.paginationResult

      // load up the userCounts from the server
      interface userCount {
        usernameSlashAddress: string,
        count: number
      }
      const senderCounts: userCount[] = response.data.senderCounts
      if (senderCounts && senderCounts.length > 0) {
        this.senders = [ { label: 'Top senders', flowAddress: null } ]
        for (const uc of senderCounts) {
          let nameToUse: string = uc.usernameSlashAddress.split('/')[0]
          const flowAddress: string = uc.usernameSlashAddress.split('/')[1]
          if (nameToUse.length === 0) nameToUse = flowAddress
          const label: string = `${nameToUse} (${uc.count})`
          this.senders.push( { label, flowAddress })
        }
      }
      const receiverCounts: userCount[] = response.data.receiverCounts
      if (receiverCounts && receiverCounts.length > 0) {
        this.receivers = [ { label: 'Top receivers', flowAddress: null } ]
        for (const uc of receiverCounts) {
          let nameToUse: string = uc.usernameSlashAddress.split('/')[0]
          const flowAddress: string = uc.usernameSlashAddress.split('/')[1]
          if (nameToUse.length === 0) nameToUse = flowAddress
          const label: string = `${nameToUse} (${uc.count})`
          this.receivers.push( { label, flowAddress })
        }
      }

      // process flowAddressToUseWhenReady if it was passed into URL
      let needToRefetch: boolean = false
      if (this.senderAddressToUseWhenReady) {
        let foundOneInExistingList: boolean

        for (const user of this.senders) {
          if (user.flowAddress === this.senderAddressToUseWhenReady) {
            this.sender = user
            foundOneInExistingList = true
          }
        }
        if (!foundOneInExistingList) {
          const addOne: { label: string, flowAddress: string } = { label: this.senderAddressToUseWhenReady, flowAddress: this.senderAddressToUseWhenReady }
          this.senders.push(addOne)
          this.sender = addOne
        }
        needToRefetch = true
      }
      this.senderAddressToUseWhenReady = null

      if (this.receiverAddressToUseWhenReady) {
        let foundOneInExistingList: boolean

        for (const user of this.receivers) {
          if (user.flowAddress === this.receiverAddressToUseWhenReady) {
            this.receiver = user
            foundOneInExistingList = true
          }
        }
        if (!foundOneInExistingList) {
          const addOne: { label: string, flowAddress: string } = { label: this.receiverAddressToUseWhenReady, flowAddress: this.receiverAddressToUseWhenReady }
          this.receivers.push(addOne)
          this.receiver = addOne
        }
        needToRefetch = true
      }
      this.receiverAddressToUseWhenReady = null

      if (needToRefetch) {
        this.pageNumberToLoadNext = 1
        return await this.fetchData(false, this.pageNumberToLoadNext)
      }

      // load up subtotals
      this.numMoments = response.data.numMoments

      // load up the FastFingerList
      this.giftingList = new GiftingList(response.data.giftList)

      // load up the moments separately from the FastFingerList object in case we want to do paging (might do everything inside FastFingerList eventually)
      let newRawItems: MomentTransferred[] = response.data.giftList.moments
      if (newRawItems) {
        newRawItems = newRawItems.map((po) => new MomentTransferred(po));
        if (pageNumberWhenCalled === 1) {
          if (newRawItems.length > 0) this.moments = [ fakeMoment ].concat(newRawItems); else this.moments = []
        } else {
          this.moments = this.moments.concat(newRawItems)
        }

        this.pageNumberToLoadNext++
        this.lastFetchSucceeded = true

        return newRawItems.length
      } else {
        this.lastFetchSucceeded = false;
        return 0
      }

    } catch (error) {
      if (error.toString().includes('Network Error') || error.toString().includes('status code 502')) utils.toast(this, 'Error', 'Undergoing Maintenance'); else utils.toast(this, 'Error', 'Could not load url')
      if (this.$store.state.devmode) console.log(error);
      return 0
    } finally {
      this.$store.commit("setLoading", { loading: false });
    }

    this.$store.commit("setLoading", { loading: false });
  }  
}
